import { useDispatch } from 'store/hooks';
import { loadCurrencies } from 'app/currencies/store/thunks';
import { useCallback } from 'react';

export const useDispatchLoadCurrency = () => {
    const dispatch = useDispatch();
    return useCallback(
        (currencyCode: string) => dispatch(loadCurrencies([currencyCode])),
        [dispatch]
    );
};
